<template lang="pug">
  #modal-detalhar-protocolos-pssc
    el-dialog(
      :title="$t('mensagens.pssc.telaVisaoGeralTerritorio.modalDetalharProtocolosTitulo')",
      :visible.sync='show_',
      :close-on-click-modal='false',
      :destroy-on-close='true',
      :show-close='false',
      custom-class='no-box-shadow',
      show-close,
      @close='closeDialog()'
    )
      div(
        style='border-bottom: solid 1px var(--default-border-color); margin-bottom: 10px; padding-bottom: 10px',
        v-for="(camada, index) in dados" :key="index"
      )
        div.titulo-camada
          | {{ camada.titulo }}
        div
          | {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.modalDetralharProtocoloPSsc.fonte') + camada.fonte.nome + $t('mensagens.pssc.telaVisaoGeralTerritorio.modalDetralharProtocoloPSsc.dataReferente') + camada.fonte.dataCadastro }}
        a.mb-2(:href="camada.fonte.url" target="_blank")
          | {{ camada.fonte.url }}

      .dialog-footer(slot='footer')
        el-button.outline-button(
          type='outline',
          size='mini',
          @click='closeDialog()'
        ) {{ $t('mensagens.comuns.fechar') }}
</template>

<script>

export default {
  name: 'ModalDetalharProtocolosPssc',
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    dados: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data() {
    return {
      show_: false
    };
  },

  watch: {
    show: {
      handler() {
        this.show_ = this.show;
        this.width = '50%';
      },
      immediate: true
    }
  },

  methods: {
    closeDialog() {
      this.show_ = false;
      this.$emit('closeDialog');
    }
  }
};
</script>

<style lang="scss">
#modal-detalhar-protocolos-pssc {
  .titulo-camada {
    font-weight: 500;
    font-size: 14px;
  }

  .el-dialog__footer {
    margin-top: 0;
    text-align: right;
    border-top: solid 2px #e7e7e7;
    background-color: #ffffff;

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      gap: 16px;
    }
  }

  .el-dialog__close {
    color: #3B3B3B;

    &:before {
      font-size: 20px;
      font-weight: 600;
    }
  }

  .outline-button {
    margin: 0px !important;
  }

  .primary-button {
    margin: 0px !important;
  }

  .modal-text {
    font-family: 'Roboto', 'sans serif';
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    padding-bottom: 8px;
  }

  .el-dialog__body {
    max-height: 525px;
    overflow-y: auto;
  }

  .el-dialog__body {
    padding: 20px;
    background-color: #ffffff;

    span {
      color: #3b3b3b;
    }
  }

  .el-dialog__header {
    padding: 15px 20px !important;
    background-color: #e9e9e9;

    .el-dialog__title {
      color: #00413c;
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;
    }
  }

  .el-dialog__body {
    max-height: 525px;
    padding: 15px;
  }

  .font-bold {
    font-weight: 600;
  }

  .el-divider--horizontal {
    margin: 15px 0 8px 0;
  }
}
</style>
